import { SelectOption } from './../models/select-option.model';
import { Locality } from './../models/locality.model';
import { Municipality } from 'src/app/models/locality.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Province } from '../models/locality.model';
import { ID } from '../models/ID.model';

@Injectable({
  providedIn: 'root'
})
export class SelectOptionsService {

    constructor(
        private http: HttpClient
    ) { }

    getProvinces() {
        return this.http.get<Province[]>(`/provincias`);
    }

    getMunicipalities(provinceId: ID) {
        return this.http.get<Municipality[]>(`/provincias/${provinceId}/municipios`);
    }

    getLocalities(provinceId: ID, municipalityId: ID) {
        return this.http.get<Locality[]>(`/provincias/${provinceId}/municipios/${municipalityId}/localidades`);
    }

    getHeadings() {
        return this.http.get<SelectOption[]>(`/rubros`);
    }

    getIvaSituations() {
        return this.http.get<SelectOption[]>(`/situacion-iva`);
    }
}
